import React from "react"

import { useStoreData, useVariant } from "./hooks"

import MapPage from "././pages/MapPagePublic"

function AppNotReady({ children }) {
    return (
        <div className="AppNotReady">
            <div>{children}</div>
        </div>
    )
}

export default function PublicApp() {
    const loadError = useStoreData("loadError")
    const { variant } = useVariant()

    if (loadError) {
        return (
            <AppNotReady>
                <div className="text-center enetz-logo">
                    <img src="/img/enetz-logo-wide.png" alt="ENETZ Logo" width="200" />
                </div>
                <div className="text-center" style={{ marginTop: "10px", fontFamily: "Arial", color: "#f41e2d" }}>
                    <b>Fehlende Datenquelle:</b>
                    <br />
                    {loadError}
                </div>
            </AppNotReady>
        )
    }

    if (!variant) {
        // No data loaded yet
        return (
            <AppNotReady>
                <div className="text-center enetz-logo">
                    <i className="fas fa-spin fa-spinner fa-4x" />
                    <img src="/img/enetz-logo-wide.png" alt="ENETZ Logo" width="200" />
                </div>
            </AppNotReady>
        )
    }

    // In the public app, .Public is hard-coded even when loading private data
    return (
        <div className={"page-container Public"}>
            <div className={"content-container Public"}>
                <MapPage />
            </div>
        </div>
    )
}
